module.exports = __webpack_public_path__ + "media/images/flags/16/Hungary-0131eac7e9c43d0401285717e67e8fec.png";